import React from 'react';
import { SimpleLineIcons } from '@expo/vector-icons';
import { colors } from '@theme';

export function StackHeaderLeft({ onPress }: { onPress: () => void }) {
  return (
    <SimpleLineIcons.Button
      name="menu"
      size={24}
      color={colors.white}
      backgroundColor={colors.transparent}
      onPress={onPress}
      //,margin left: 10
      style={{ marginLeft: 0 }}
    />
  );
}

export function StackHeaderLeftDark({ onPress }: { onPress: () => void }) {
  return (
    <SimpleLineIcons.Button
      name="menu"
      size={24}
      color={colors.smartPurple}
      backgroundColor={colors.transparent}
      onPress={onPress}
      //,margin left: 10
      style={{ marginLeft: 20 }}
    />
  );
}

export function StackHeaderLeftBack({ onPress }: { onPress: () => void }) {
  return (
    <SimpleLineIcons.Button
      name="arrow-left"
      size={24}
      color={colors.white}
      backgroundColor={colors.transparent}
      onPress={onPress}
      //,margin left: 10
      style={{ marginLeft: 0 }}
    />
  );
}

export function StackHeaderLeftBackDark({ onPress }: { onPress: () => void }) {
  return (
    <SimpleLineIcons.Button
      name="arrow-left"
      size={24}
      color={colors.smartPurple}
      backgroundColor={colors.transparent}
      onPress={onPress}
      //,margin left: 10
      style={{ marginLeft: 20 }}
    />
  );
}
